<template>
    <div>
        <el-form
            ref="form"
            :inline="true"
            :model="query"
            class="query-form filter-block"
            size="mini"
        >
            <el-form-item label="对比Asin:" class="query-form-item">
                <el-input
                    v-model="query.compare_asin"
                    placeholder="请输入对比Asin"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                >查询
                </el-button
                >
                <!--                <el-button @click="download_file" type="primary" size="mini"-->
                <!--                >导出数据</el-button-->
                <!--                >-->

                <el-button
                    style="margin: 5px 0 5px 10px"
                    type="success"
                    size="mini"
                    @click.native="generateNewData()"
                >生成最新数据
                </el-button
                >
                <el-button
                    style="margin: 5px 0 5px 10px"
                    type="success"
                    size="mini"
                    @click.native="downloadList()"
                >下载列表
                </el-button
                >

                <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini" @click.native="onDelete()">批量删除
                </el-button>
                <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini" @click.native="onDeleteAll()">全部删除
                </el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;"
        >
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column label="ID" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="父Asin" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.parent_asin }}</div>
                </template>
            </el-table-column>
            <el-table-column label="对比Asin" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.keyword_asin }}</div>
                </template>
            </el-table-column>
            <el-table-column label="产品价格" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.buybox_price }}</div>
                </template>
            </el-table-column>
            <el-table-column label="产品品牌" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.listing_brand }}</div>
                </template>
            </el-table-column>
            <el-table-column label="产品评论数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.grade_number }}</div>
                </template>
            </el-table-column>
            <el-table-column label="最新采集时间" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.spider_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="展示量" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.impressions }}</div>
                </template>
            </el-table-column>
            <el-table-column label="点击量" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.clicks }}</div>
                </template>
            </el-table-column>
            <el-table-column label="花费" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.spend }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Bid" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.bid }}</div>
                </template>
            </el-table-column>
            <el-table-column label="订单数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.orders }}</div>
                </template>
            </el-table-column>
            <el-table-column label="总销量" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.units }}</div>
                </template>
            </el-table-column>
            <el-table-column label="销售额" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.sales }}</div>
                </template>
            </el-table-column>
            <el-table-column label="acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.acos }}</div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: left;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <download-list :visible="this.downloadListVisible" @close-callback="closeCllback"
                       :id="datasrow.id"></download-list>
    </div>
</template>

<script>
    import * as api from '@/api/Product/Product.js'
    import {downloadFileUrl} from '@/utils/method'
    import DownloadList from './downloadList8'

    export default {
        props: {
            datasrow: {
                type: Object,
                default: () => {
                }
            }
        },
        components: {DownloadList},
        data() {
            return {
                downloadListVisible: false,
                query: {
                    page: 1,
                    limit: 20,
                    asin: null
                },
                list: [],
                multipleSelection: [],
                disabled: false,
                loading: false
            }
        },
        mounted() {
            // this.query.asin = this.datasrow.parent_asin;
            // this.getList();
        },
        methods: {
            closeCllback(isshow) {
                this.downloadListVisible = false
                if (isshow) return
                this.getList()
            },
            downloadList() {
                this.downloadListVisible = true
            },
            generateNewData(force = 0) {
                api.compare_asin_create_excel_file({
                    id: this.datasrow.id,
                }).then(res => {
                    if (res.success) {
                        this.$message({
                            message: res.data,
                            type: 'success'
                        })
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            getList(asin, state) {
                this.loading = true
                this.query.asin = asin || this.query.asin
                this.query.state = state || this.query.state
                api.seed_word_compare_asin_list(this.query)
                    .then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.list = res.data.list
                            this.query.total = res.data.total
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            onDelete() {
                if (this.multipleSelection.length == 0) {
                    return this.$message({
                        type: 'error',
                        message: '请勾选需要删除的核心词根！'
                    })
                }
                this.$confirm(
                    `确定要删除 ${this.query.asin} 下的 ${this.multipleSelection.length} 个asin数据吗？`,
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                )
                    .then(() => {
                        this.loading = true
                        api.seed_word_compare_asin_delete({
                            ids: this.multipleSelection,
                            all_deleted: 0,
                            asin: this.query.asin,
                            state: this.query.state,
                        })
                            .then(res => {
                                this.loading = false
                                if (res.code === 0) {
                                    this.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    })
                                    this.getList()
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(() => {
                                this.loading = false
                            })
                    })
                    .catch(() => {
                    })
            },
            onDeleteAll() {
                this.$confirm(`确定要删除全部asin数据吗？`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.loading = true
                        api.seed_word_compare_asin_delete({
                            ids: this.multipleSelection,
                            all_deleted: 1,
                            asin: this.query.asin,
                            state: this.query.state,
                        })
                            .then(res => {
                                this.loading = false
                                if (res.code === 0) {
                                    this.$message({
                                        message: '全部删除成功',
                                        type: 'success'
                                    })
                                    this.getList()
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(() => {
                                this.loading = false
                            })
                    })
                    .catch(() => {
                    })
            },
            //多选框
            handleSelectionChange(val) {
                let arr = []
                val.map(v => {
                    arr.push(v.id)
                })
                this.multipleSelection = arr
            },
            download_file() {
                api.asin_keyword_file_export({
                    asin: this.query.asin,
                    state: this.query.state
                }).then(res => {
                    if (res.success) {
                        downloadFileUrl(res.data)
                    }
                })
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    .filter-block {
        background-color: #a9c7ff;
        padding: 6px 6px 6px 10px;
        font-size: 18px;
        color: #333;
        margin: 0;
        display: flex;
        align-items: center;
    }

    /deep/ .warningred {
        background: rgb(243, 107, 107) !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 0 !important;
    }
</style>
